module.exports = __webpack_public_path__ + "img/logoCreditpush_black.b78360eb.svg";